module.exports = __webpack_public_path__ + "img/awards_100.1feddb16.png";